import { useState, useEffect } from 'react';

/**
 * this hook will help to prevent reload and close tab.
 */

const useUnsavedChangesWarning = (message = 'Leaving this page will discard unsaved changes.') => {
  const [isDirty, setIsDirty] = useState(false);

  const handleWindowClose = (e) => {
    if (!isDirty) return;
    e.preventDefault();
    return (e.returnValue = message);
  };

  useEffect(() => {
    window.addEventListener('beforeunload', handleWindowClose);

    return () => {
      window.removeEventListener('beforeunload', handleWindowClose);
    };
  }, [isDirty]);

  return [isDirty, setIsDirty];
};

export default useUnsavedChangesWarning;
